export { checkIfAccountTabScreen } from './checkIfAccountTabScreen';
